import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Form, FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';



import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { Payment } from './../../../shared/models/payment.model';

import { NgForm } from '@angular/forms';
import { MyobApiInvoiceSyncToolsWidgetComponent } from '../../myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component';

@Component({
  selector: 'app-invoice-status-change-widget',
  templateUrl: './invoice-status-change-widget.component.html',
  styleUrls: ['./invoice-status-change-widget.component.css']
})
export class InvoiceStatusChangeWidgetComponent implements OnInit, OnChanges {
     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
     job: Object;
     @Input() job_id: Observable<any[]>; 
     @Input() subject_id: Observable<any[]>; 
     @Input() subject_number?: Observable<any[]>;
     @Input() job_number: Observable<any[]>;
     @Input() invoice_id: Observable<any[]>;
   
   // access the template form
   @ViewChild('invoiceForm') invoiceForm: NgForm;

    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
    @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
    @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();

  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: Date;
  today: string | number | Date;
  brand_invoice_id: any;
  invoice_job_type_id: any;
  invoice_item_model: any;
  invoiceItemsList: Object;
  subject: Object;
  invoice_model: any;
  invoiceItem: any;
  invoice_number: any;
  owner_brand: Object;
  invoice_status: Object;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: Object;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: Object;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  invoice_status_all: any;
  invoice_payment_status_all: Object;
  invoice_communication_status_all: Object;
  original_invoice_status: any;
  original_invoice_payment_status: any;
  original_invoice_communication_status: any;
 //   @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private cdr:ChangeDetectorRef, // allows for change detection once pushed data to an array
     public _MyobApiInvoiceSyncToolsWidgetComponent: MyobApiInvoiceSyncToolsWidgetComponent
  )  {
    // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

   // need to add this as routes does not work globally
   this.all_router_details = this.router.url;
   this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


// Date picker date format
this.valueDatePickerDate = new Date(this.today);
  }

  // check for changes. to load data.
  ngOnChanges(changes) {


if (changes.invoice_id) {
 this.invoice_id = changes.invoice_id.currentValue;
 this.getJobSubject(this.subject_id);
 this.getJob(this.job_id);
 this.getInvoiceStatusAll();
 this.getInvoicePaymentStatusAll();
 this.getInvoiceCommunicationStatusAll();
 this.getInvoice(this.invoice_id);
}



if (changes.item_id) {
     // deal with asynchronous Observable result
   //  this.job_id = changes.item_id.currentValue;
     // this.getJob(this.job_id);
   }
 }
 



  
  ngOnInit() {
  }



// Functions

updateInvoiceStatus(invoice_model){
  invoice_model.invoice_id = this.invoice_id;
  this._demoService.updateInvoiceStatus(invoice_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:
  this.refreshInvoiceItemsBelow.emit();
  this.closeParentModel2.emit();
    },
    error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Changing Status of Subject');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};

 
getInvoice(invoice_id){
  this._demoService.getSubjectInvoice(invoice_id).subscribe(
    (data) => {
      this.invoiceItem = data;
      let res = data[0];
      this.invoice_number = res.invoice_number;

      // Set status based in ID - For template interactions // RULES
      // this.invoice_status_text = 'PAID';
      this.getInvoiceStatus(res.invoice_status_id);
      this.getInvoicePaymentStatus(res.invoice_payment_status_id);
      this.getInvoiceCommunicationStatus(res.invoice_communication_status_id);

     // this.invoice_model = this.invoiceItem;
  
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  ) };


   
 getInvoiceItmes(invoice_id){
  this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
    (data) => {
      this.invoiceItemsList = data;
      let res = data[0];

      this.invoice_item_model = this.invoiceItemsList;
     
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  ) };



  
  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
      data => { this.subject = data;
        let res = data[0];
        this.subject_number = res.subject_number;
       // this.job_number = res.job_id + '.1'; // made up
       // console.log("Done loadng USER");
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }


  getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
      // Run the job data queries.
    this.brand_invoice_id =  res.brand_invoice_id;
    this.invoice_job_type_id = res.job_type_id;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 private getOwnerBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.owner_brand = data;
      let res = data[0];
    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}



getInvoiceStatus(invoice_status_id){
  this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
    (data) => {
      this.invoice_status = data;
      let res = data[0];
      this.invoice_status_name = res.invoice_status_name;
      this.invoice_status_var = invoice_status_id;
      this.original_invoice_status = res.invoice_status_name;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



getInvoicePaymentStatus(invoice_payment_status_id){
  this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
    (data) => {
      this.invoice_payment_status = data;
      let res = data[0];
      this.invoice_payment_status_name = res.invoice_payment_status_name;
      this.invoice_payment_status_var = invoice_payment_status_id;
      this.original_invoice_payment_status = res.invoice_payment_status_name;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatus(invoice_communication_status_id){
  this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
    (data) => {
      this.invoice_communication_status = data;
      let res = data[0];
      this.invoice_communication_status_name = res.invoice_communication_status_name;
      this.invoice_communication_status_var = invoice_communication_status_id;
      this.original_invoice_communication_status = res.invoice_communication_status_name;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}





getInvoiceStatusAll(){
  this._demoService.getInvoiceStatusAll().subscribe(
    (data) => {
      this.invoice_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getInvoicePaymentStatusAll(){
  this._demoService.getInvoicePaymentStatusAll().subscribe(
    (data) => {
      this.invoice_payment_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatusAll(){
  this._demoService.getInvoiceCommunicationStatusAll().subscribe(
    (data) => {
      this.invoice_communication_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}






}
